exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-11c63270] {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  height: 100vh;\n  z-index: 99999 !important;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.loading i[data-v-11c63270] {\n  position: absolute;\n  opacity: 1;\n}\n", ""]);

// exports
